function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m0.59568 20.074c0-10.767 8.7071-19.513 19.435-19.513 10.748 0 19.435 8.746 19.435 19.513 0 10.787-8.6877 19.513-19.435 19.513-10.728 0-19.435-8.7265-19.435-19.513z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(.97139 0 0 .97139 -.57045 -.60537)",
  d: "m1.2005 21.288c0-11.084 8.9636-20.088 20.008-20.088 11.064 0 20.008 9.0036 20.008 20.088 0 11.104-8.9436 20.088-20.008 20.088-11.044 0-20.008-8.9836-20.008-20.088",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8,
  strokeWidth: 1.0295
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(.31257 -1.1114)"
}, React.createElement("path", {
  d: "m27.768 10.95c0.18877-0.20768 0.52854-0.22656 0.75506-0.03776l2.9259 2.5865c0.20764 0.1888 0.22652 0.52863 0.03775 0.75519l-1.3969 1.5859c-0.20764 0.20768-0.52854 0.22656-0.75506 0.03776l-2.9259-2.5865c-0.20764-0.1888-0.22652-0.52863-0.03775-0.73631z",
  fill: "#adb9ca",
  fillRule: "evenodd"
}), React.createElement("path", {
  d: "m27.768 10.95c0.18877-0.20768 0.52854-0.22656 0.75506-0.03776l2.9259 2.5865c0.20764 0.1888 0.22652 0.52863 0.03775 0.75519l-1.3969 1.5859c-0.20764 0.20768-0.52854 0.22656-0.75506 0.03776l-2.9259-2.5865c-0.20764-0.1888-0.22652-0.52863-0.03775-0.73631z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.91982 0 0 1 1.9366 -.76407)",
  strokeWidth: 1.0427
}, React.createElement("path", {
  d: "m15.555 5.2669h8.249c0.43416 0 0.77394 0.35872 0.77394 0.79295v3.1152c0 0.43424-0.33978 0.77407-0.77394 0.77407h-1.5668v0.58527c0 0.43424-0.35865 0.77407-0.79281 0.77407h-3.5488c-0.43416 0-0.77394-0.33984-0.77394-0.77407v-0.58527h-1.5668c-0.43416 0-0.79281-0.33984-0.79281-0.77407v-3.1152c0-0.43424 0.35865-0.79295 0.79281-0.79295z",
  fill: "#adb9ca",
  fillRule: "evenodd"
}), React.createElement("path", {
  d: "m15.555 5.2669h8.249c0.43416 0 0.77394 0.35872 0.77394 0.79295v3.1152c0 0.43424-0.33978 0.77407-0.77394 0.77407h-1.5668v0.58527c0 0.43424-0.35865 0.77407-0.79281 0.77407h-3.5488c-0.43416 0-0.77394-0.33984-0.77394-0.77407v-0.58527h-1.5668c-0.43416 0-0.79281-0.33984-0.79281-0.77407v-3.1152c0-0.43424 0.35865-0.79295 0.79281-0.79295z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.0427
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.0898 0 0 1.0898 -1.81 -3.1903)",
  strokeWidth: 0.91759
}, React.createElement("path", {
  d: "m10.813 23.894c0-5.1909 4.1962-9.4247 9.3493-9.4247 5.1716 0 9.3493 4.2337 9.3493 9.4247 0 5.2093-4.1778 9.4247-9.3493 9.4247-5.1532 0-9.3493-4.2153-9.3493-9.4247z",
  fill: "#ecaec6",
  fillRule: "evenodd"
}), React.createElement("path", {
  d: "m20.016 15.261c-4.8035 0-8.7236 3.9392-8.7236 8.7804 0 4.8596 3.9201 8.7988 8.7236 8.7988 4.8219 0 8.742-3.9392 8.742-8.7988 0-4.8412-3.9201-8.7804-8.742-8.7804zm0-2.7059c6.3126 0 11.411 5.1541 11.411 11.486 0 6.3506-5.098 11.486-11.411 11.486-6.2942 0-11.411-5.1357-11.411-11.486 0-6.3322 5.1164-11.486 11.411-11.486z",
  fill: "#adb9ca",
  fillRule: "evenodd"
}), React.createElement("path", {
  d: "m20.016 15.261c-4.8035 0-8.7236 3.9392-8.7236 8.7804 0 4.8596 3.9201 8.7988 8.7236 8.7988 4.8219 0 8.742-3.9392 8.742-8.7988 0-4.8412-3.9201-8.7804-8.742-8.7804zm0-2.7059c6.3126 0 11.411 5.1541 11.411 11.486 0 6.3506-5.098 11.486-11.411 11.486-6.2942 0-11.411-5.1357-11.411-11.486 0-6.3322 5.1164-11.486 11.411-11.486z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.91759
}), React.createElement("path", {
  d: "m27.028 20.967c0.14723 0.33134 0 0.71789-0.33128 0.86515l-4.3802 1.9512 0.05521 0.22089c0.01841 0.90197-0.47851 1.7487-1.3251 2.1353-1.1411 0.497-2.4846-0.01841-2.9999-1.1781-0.51532-1.1413 0-2.5034 1.1411-3.0004 0.84659-0.38656 1.822-0.18408 2.4662 0.42337l0.12883 0.20248 4.3802-1.9512c0.33128-0.14726 0.71776 0 0.865 0.33134z",
  fill: "#adb9ca",
  fillRule: "evenodd"
}), React.createElement("path", {
  d: "m27.028 20.967c0.14723 0.33134 0 0.71789-0.33128 0.86515l-4.3802 1.9512 0.05521 0.22089c0.01841 0.90197-0.47851 1.7487-1.3251 2.1353-1.1411 0.497-2.4846-0.01841-2.9999-1.1781-0.51532-1.1413 0-2.5034 1.1411-3.0004 0.84659-0.38656 1.822-0.18408 2.4662 0.42337l0.12883 0.20248 4.3802-1.9512c0.33128-0.14726 0.71776 0 0.865 0.33134z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.91759
}), React.createElement("path", {
  d: "m19.942 20.415v-3.884c2.3005 0 4.4354 1.2885 5.4476 2.9084l-3.6072 1.6567c-0.38649-0.36815-1.1043-0.71789-1.8404-0.68108z",
  fill: "#fff",
  fillRule: "evenodd"
}), React.createElement("path", {
  d: "m19.942 20.415v-3.884c2.3005 0 4.4354 1.2885 5.4476 2.9084l-3.6072 1.6567c-0.38649-0.36815-1.1043-0.71789-1.8404-0.68108z",
  fill: "none",
  stroke: "#002060",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.55055
}));
var SvgRunSurveyTab = function SvgRunSurveyTab(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRunSurveyTab, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Run-Survey-Tab.be3be184.svg";
export { ForwardRef as ReactComponent };